import { motion } from 'framer-motion';
import { LOGOS } from '@/i18n';

// Big branded seal between sections — adds WOW and reinforces brand identity
const BrandSeal = ({ variant = 'horizontal', kicker, tagline, testId = 'brand-seal' }) => {
  const src = variant === 'horizontal' ? LOGOS.logo_horizontal_dark : LOGOS.isologo_dark_bg;
  const sizeCls = variant === 'horizontal' ? 'h-12 sm:h-16 md:h-20' : 'h-16 sm:h-20 md:h-24';

  return (
    <section className="relative py-16 sm:py-20 bg-[rgb(var(--bg-0))] overflow-hidden" data-testid={testId}>
      {/* decorative glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[260px] rounded-full blur-3xl bg-[rgba(5,126,243,.18)]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {kicker && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="kicker-mono text-white/60 mb-5"
          >
            {kicker}
          </motion.div>
        )}

        <motion.img
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
          src={src}
          alt="Cauratech"
          className={`mx-auto w-auto ${sizeCls} drop-shadow-[0_0_40px_rgba(5,126,243,.35)]`}
        />

        {tagline && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mt-6 font-display text-xl sm:text-2xl lg:text-3xl font-[650] text-white tracking-tight"
          >
            {tagline}
          </motion.p>
        )}

        <div className="mt-7 mx-auto h-px w-40 bg-gradient-to-r from-transparent via-[rgb(var(--brand-electric))] to-transparent" />
      </div>
    </section>
  );
};

export default BrandSeal;
